import { render, staticRenderFns } from "./DCConfirmCollected.vue?vue&type=template&id=16fb7029&"
import script from "./DCConfirmCollected.vue?vue&type=script&lang=js&"
export * from "./DCConfirmCollected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports